import './HomePage.css';
import BalanceCard from '../BalanceCard/BalanceCard';
import Navigation from '../Navigation/Navigation';
import Timer from '../Timer/Timer';
import { resources } from '../../utils/resources';
import { useUI } from '../../hooks/useUI';

const HomePage = (props) => {
    const { userData } = useUI();
    
    return (
        <div className='homePage' style={{ backgroundImage: `url(${resources.images.mainIllustration})` }}>
            <div className="container">
                <div className="homePage__inner">
                    <div className='homePage__titleBlock'>
                        <div className='homePage__title appearanceAnimation'>Bank Of Mining</div>
                        <div className="homePage__subtitle appearanceAnimation">Transparently Earn Gold, Silver & Other Precious Metal Tokens</div>
                    </div>
                    <div className='homePage__balanceTitle appearanceAnimation'>My balance</div>
                    <div className='homePage__balanceCards'>
                        <BalanceCard value={Math.floor(props.usdBalance)} icon={resources.icons.dollar} title='USD' background={resources.images.balanceImg1} />
                        <BalanceCard value={Math.floor(props.mainBalance)} icon={resources.icons.dollar} title='BOM' background={resources.images.balanceImg2} />
                        <BalanceCard value={Math.floor(userData.user_wbom_balance)} icon={resources.icons.dollar} title='WBOM' background={resources.images.balanceImg2} />
                    </div>
                    <div className="homePage__timerBlock">
                        <Timer
                            countdown={3600000}
                            text={'Till next payment'}
                            autoCount={true}
                            id='homePage'
                            reverseProgress={true}
                        />
                    </div>
                </div>
                <Navigation />
            </div>
        </div>
    );
};

export default HomePage;